import { createFileRoute } from "@tanstack/react-router"
import { SocialMatchDashboardPage } from "@/features/social-match-simulation"

export const Route = createFileRoute("/_authenticated/social-match/dashboard")({
	component: SocialMatchDashboardPage,
})
